import React from 'react'
import { Section, H2, ContainerLg, Lead } from '../../GlobalStylesNew'
import { Row, Col } from 'reactstrap'
import styled from 'styled-components'
import theme from '../../theme'

export const WelcomeSection = styled(Section)`
  background-color: ${p => p.theme.colors.navy};
  padding: 50px 0 20px;
  text-align: left;
  @media screen and (min-width: 768px) {
    padding: 100px 0 70px;
  }
  @media screen and (min-width: 1024px) {
    padding: 150px 0 120px;
  }
`

export const CustomHeading = styled(H2)`
  color: ${theme.colors.white};
  margin-bottom: 20px;
  text-align: center;
  @media screen and (min-width: 768px) {
    text-align: left;
    margin-bottom: 20px;
  }
`

export const VideoWrapper = styled.div`
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
  margin-bottom: 50px;
  &:before {
    display: block;
    content: '';
    padding-top: 56.25%;
  }
  iframe {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`

const Video = ({ src }) => (
  <iframe
    src={src}
    title='PGA Coach'
    frameBorder='0'
    webkitallowfullscreen='true'
    mozallowfullscreen='true'
    allowFullScreen
  />
)

const Welcome2 = props => {
  return (
    <WelcomeSection id='features'>
      <ContainerLg className='container-xl'>
        <Row>
          <Col lg='4'>
            <CustomHeading>Welcome to PGA Coach</CustomHeading>
            <Lead>
              Let's maximize each athlete's potential; create well-rounded
              athletes and develop principles that create life-long golfers and
              athletes for generations.
            </Lead>
            <Lead>
              Now is the time to start your journey with PGA Coach training, and
              gain access to all of the tools you need to create passionate
              students and life-long golfers.
            </Lead>
          </Col>
          <Col lg='7' className='offset-lg-1'>
            <VideoWrapper>
              <Video src='https://player.vimeo.com/video/318557649?byline=0&title=0' />
            </VideoWrapper>
          </Col>
        </Row>
      </ContainerLg>
    </WelcomeSection>
  )
}

export default Welcome2
